import { buildQueryParams } from '@/helpers/ApiHelper'
import type { ILoyaltyPagedResponse } from '@/models/Loyalty/ILoyaltyPagedResponse'
import type { ILoyaltyUser } from '@/models/Loyalty/ILoyaltyUser'
import { inject, injectable } from 'inversify'
import type IApiClient from '../IApiClient'
import { SERVICES_TYPES } from '../ServicesTypes'
import type ILoyaltyService from './ILoyaltyService'

@injectable()
export class LoyaltyService implements ILoyaltyService {
  private readonly apiClient: IApiClient
  private readonly usersPrefix: string = 'loyalty/users'

  constructor(@inject(SERVICES_TYPES.ApiClient) apiClient: IApiClient) {
    this.apiClient = apiClient
  }

  public getUsers(pageIndex: number, pageSize: number, filter?: string, abortController?: AbortController): Promise<ILoyaltyPagedResponse<ILoyaltyUser>> {
    if (abortController?.signal.aborted) {
      return Promise.reject(abortController.signal.reason)
    }
    const query = buildQueryParams({ pageIndex, pageSize, filter: filter?.trim() || undefined })
    return this.apiClient.get<ILoyaltyPagedResponse<ILoyaltyUser>>(`${this.usersPrefix}${query}`, abortController)
  }
}
